import styled from 'styled-components'

export const Wrapper = styled.section`
  margin-top: 100px;
  ${({ theme }) => theme.below.laptop`
    margin-top: 50px;
    padding: 0 ${theme.spaces[3]}px;
  `}
`
